.kdx-testimonials-slider {
    
    .slide-item {        

        .row { 
            align-items: center; 
            height: 100%;
        }
        img { max-height: 376px; }
    }
    .kdx-carousel.-cards-slider .glide__slides { padding: 0; }
    .kdx-carousel .bullets-wrapper.external { margin-top: 24px; }
}




@include media-breakpoint-down(md) {
    .kdx-testimonials-slider {
        padding-bottom: 40px;

        .row {
            & > [class^="col-"] { margin-bottom: 28px; }
        }
        .slide-item {

            .row { height: auto; }
        }
        .kdx-carousel {

            .bullets-wrapper.external { margin-top: 0; }
            &.-cards-slider {
                width: 100%;
    
                .controls button {
                    top: auto;
                    bottom: -75px;
                    left: calc(50% - 42px);
                    transform: none;
    
                    &.right-btn {
                        right: calc(50% - 42px);
                        transform: none;
                    }
                }
            }
        }
    }
}




@include media-breakpoint-down(sm) {
    .kdx-testimonials-slider {

        .kdx-generic-content {

            .btn { width: 100%;}
        }
    }
}